import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faUser as faUserSolid } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-user-banner-header',
  templateUrl: './user-banner-header.component.html',
  styleUrls: ['./user-banner-header.component.scss'],
  standalone: false
})
export class UserBannerHeaderComponent {
  @Input() title = '';
  @Input() forename = '';
  @Input() surname = '';
  @Input() headingId = '';
  @Input() showDoubleIcon = false;
  @Input() showCollapseButton = false;

  @Output() collapseClick = new EventEmitter<void>();

  faUserSolid = faUserSolid;

  onCollapseClick(): void {
    this.collapseClick.emit();
  }
}
